// ======================================================================
// File Name       : ContentAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import _ from 'lodash';
import { CONTENT_VIDEO_SEARCH,
         VIDEO_URL, VIDEO_EDIT,
         CONTENT_DRILL_LIST_SEARCH,
         CONTENT_DRILL_LIST_DOWNLOAD,
         CONTENT_DRILL_DETAIL,
         CONTENT_DELETE_DRILL,
         CONTENT_DRILL_SKIN_LIST,
         CONTENT_DRILL_EDIT } from '../constants/ActionTypes';
import { DRILL_SKIN_CLIENT_URL } from '../constants/index';
import { commonCallApi } from '../utils/ApiUtils';
import * as contentRequests from './httpRequests/content';
import * as contentActionCreators from './actionCreators/content';

/**
 * Store content video list
 * @param {*} contentInfo
 */
function receiveContentVideoList(videoInfo) {
  return {
    type: CONTENT_VIDEO_SEARCH,
    videoInfo,
  };
}

/**
 * Action content video get list
 * @param {*} searchInfo
 */
export function getVideoList(searchInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'video/GetList',
      data: searchInfo,
      institutionId: 1,
    }).then((camelizeJson) => {
      dispatch(receiveContentVideoList(camelizeJson));
    });
  };
}

/**
 * Store content video edit respond
 * @param {*} contentInfo
 */
function receiveVideoEditRespond(videoEditRespond) {
  return {
    type: VIDEO_EDIT,
    videoEditRespond,
  };
}

export function contentVideoEdit(searchInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'video/Edit',
      data: searchInfo,
      institutionId: 1,
    }).then((camelizeJson) => {
      dispatch(receiveContentVideoList(camelizeJson));
    });
  };
}

/**
 * Store video
 * @param {*} contentInfo
 */
function receiveVideo(videoUrl) {
  return {
    type: VIDEO_URL,
    videoUrl,
  };
}

export function getVideo(videoInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'video/GetVideo',
      data: videoInfo,
      institutionId: 1,
    }).then((camelizeJson) => {
      dispatch(receiveVideo(camelizeJson));
    });
  };
}

/**
 * Action content drill get list
 * @param {*} searchInfo
 */
export function searchDrillList(searchInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'DrillList',
      data: searchInfo,
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_LIST_SEARCH,
        drillListSearchResult: result,
      });
    });
  };
}

/**
 * Action download drill  list
 * @param {*} searchInfo
 */
export function downloadDrillList(searchInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'private/DrillListDownload',
      data: searchInfo,
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_LIST_DOWNLOAD,
        drillListDownloadResult: result,
      });
    });
  };
}

/**
 * Action get drill detail
 * @param {*} drillId
 */
export function getDrillDetail(drillId) {
  return (dispatch) => {
    commonCallApi({
      path: 'DrillDetail',
      data: { drill_secern_id: drillId },
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_DETAIL,
        drillDetailInfoResult: result.drillInfo || null,
      });
      dispatch(getSkinList(result.drillInfo));
    });
  };
}

/**
 * Action get skin list
 * @param {*} drillDetailInfo
 */
export function getSkinList(drillDetailInfo) {
  if (!drillDetailInfo) {
    return null;
  }
  return (dispatch) => {
    commonCallApi({
      path: 'SkinList',
      data: { skin_set_secern_id: drillDetailInfo.skinSetSecernId },
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_SKIN_LIST,
        skinListResult: result,
      });
    });
  };
}

/**
 * Action delete drill
 * @param {*} drillId
 */
export function deleteDrill(drillId) {
  return (dispatch) => {
    commonCallApi({
      path: 'DrillDelete',
      data: { drill_secern_id: drillId },
      drillServer: true,
    }).then((result) => {
      dispatch({
        type: CONTENT_DELETE_DRILL,
        drillDetailInfoResult: result,
      });
    });
  };
}

/**
 * Action content drill update
 * @param {*} drillInfo
 */
export function updateDrill(drillInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'DrillUpdate',
      data: drillInfo,
      drillServer: true,
      muiltipart: 1,
    }).then((result) => {
      dispatch({
        type: CONTENT_DRILL_EDIT,
        drillUpdateInfo: result,
      });
    });
  };
}

export function cacheSkinList() {
  return async (dispatch, getState) => {
    let skinList = [];
    const { authedUser: { institutionId } } = getState().authed;
    const skinListRes = await contentRequests.getSkinList();
    if (skinListRes && skinListRes.skinList && skinListRes.skinList.length) {
      skinList = skinListRes.skinList;
    }
    createIframes(skinList, institutionId);
    return dispatch(contentActionCreators.receiveSkinListToCache(skinList, institutionId));
  };
}

function createIframes(skinList, institutionId) {
  if (skinList && skinList.length) {
    skinList.map((skin, index) => {
      const iframeSrc = DRILL_SKIN_CLIENT_URL.replace(':institutionId', institutionId).replace(':skinSetSecernId', skin.skinSetSecernId);
      iframeForCache(iframeSrc, skin.skinSetSecernId, institutionId);
      return null;
    });
  }
}

function iframeForCache(url, skinSetSecernId, institutionId) {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('id', `${institutionId}##${skinSetSecernId}`);
  iframe.setAttribute('class', 'cached_skin');
  iframe.setAttribute('frameBorder', '100');
  iframe.setAttribute('scrolling', 'yes');
  iframe.style.position = 'absolute';
  iframe.style.top = '-999px';
  iframe.style.left = '-999px';
  iframe.style.width = '10px';
  iframe.style.height = '5px';
  iframe.src = url;
  document.body.appendChild(iframe);
}

//STEP9.0.0 START
export function getDrillQuestionListForSort(groupIndex, drillGroupId) {
  return contentActionCreators.getDrillQuestionListForSort(groupIndex, drillGroupId);
}

export function updateDisplayOrderStructureList(structureSecernIdList) {
  return contentActionCreators.updateDisplayOrderStructureList(structureSecernIdList);
}

export function saveDisplayOrderDrillQuestion() {
  return contentActionCreators.saveDisplayOrderDrillQuestion();
}
//STEP9.0.0 END
